import React from 'react';
import { useCallback, useEffect, useRef, useState } from "react";
import { useWavesurfer } from "./useWavesurfer";
import { Duration } from "./Duration";
import { IconButton } from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import './waveSurferPlayer.css';

export const WaveSurferPlayer = (props: any) => {
    const containerRef = useRef<any>()
    const [isPlaying, setIsPlaying] = useState(false)
    const [currentTime, setCurrentTime] = useState(0)
    const [duration, setDuration] = useState(0)
    const wavesurfer = useWavesurfer(containerRef, props)

    const onPlayClick = useCallback(() => {
        wavesurfer?.isPlaying() ? wavesurfer?.pause() : wavesurfer?.play()
    }, [wavesurfer])

    useEffect(() => {
        if (!wavesurfer) return

        setCurrentTime(0)
        setIsPlaying(false)

        const subscriptions = [
            wavesurfer.on('play', () => setIsPlaying(true)),
            wavesurfer.on('pause', () => setIsPlaying(false)),
            wavesurfer.on('timeupdate', (currentTime: any) => {
                setCurrentTime(Math.round(currentTime * 100))
            }),
            wavesurfer.on('ready', () => {
                setDuration(Math.round(wavesurfer.getDuration() * 100))
            }),
        ]

        return () => {
            subscriptions.forEach((unsub) => unsub())
        }
    }, [wavesurfer])

    return (
        <div className="container-wave-surfer" style={{ backgroundColor: '#24242e' }}>
            <IconButton
                size='small'
                onClick={onPlayClick}
                sx={{ color: 'rgba(255,255,255,0.85)', flexShrink: 0 }}
            >
                {isPlaying ? <PauseIcon /> : <PlayArrowIcon />}
            </IconButton>

            <div className="container-time-progress">
                <Duration centiseconds={currentTime} />
                -<Duration centiseconds={duration - currentTime} />
            </div>

            <div className="wave-surfer-project" ref={containerRef} />
        </div>
    )
}
